<div class="category-page">
    <div class="pt-5 pb-5 mb-4"
        style="background-color: #ffd700; border-bottom-left-radius: 45% 35px; border-bottom-right-radius: 45% 35px;">
        <div class="container text-start">
            <h2 class="fw-bold mb-3 display-4 text-capitalize">{{categoryName}} Deals</h2>
            <p class="lead mb-0">
                Explore today’s best {{ categoryName | lowercase }} deals from leading brands and trusted sellers,
                all in one place. Scroll down to discover more great offers waiting for you.
            </p>

        </div>
    </div>

    <div class="container my-5">
        <div class="row">
            <!-- Main Content: Deals List -->
            <div class="col-md-12">
                <h3 class="fw-bold mb-4 text-capitalize">Top {{categoryName}} Deals</h3>

                <!-- Deal Card Loop -->
                <a class="card mb-4 border rounded-3 overflow-hidden shadow-sm text-decoration-none text-dark"
                    *ngFor="let product of products | slice:0:visibleCount" [routerLink]="['/view', product.id]"
                    target="_blank" rel="noopener">
                    <div class="row g-0 align-items-center">
                        <div class="col-md-4">
                            <!-- Placeholder image replicating the product shot -->
                            <img [src]="product.imageUrl" class="img-fluid w-100 object-fit-cover"
                                style="height: 220px;" [alt]="product.title">
                        </div>
                        <div class="col-md-8">
                            <div class="card-body p-4">
                                <h5 class="card-title fw-bold mb-3">{{product.title}}</h5>
                                <span
                                    class="text-decoration-none text-dark fw-bold border-bottom border-dark border-2 pb-1">
                                    Here's the deal <span class="ms-1">&rsaquo;</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </a>

                <div class="text-start mt-4" *ngIf="visibleCount < products.length">
                    <button class="btn btn-outline-dark rounded-pill px-5 fw-bold" (click)="seeMore()">See More <i
                            class="fa-solid fa-chevron-down"></i></button>

                </div>

            </div>


        </div>

        <small class="text-muted d-block mt-5 pt-3 border-top description-footer">
            Deals and Pubs operates as an ad-supported service. Our site may feature affiliate links, through which we
            may earn a commission at no additional cost to you. Some content may be sponsored by brands or product
            creators. For full transparency, please refer to our advertiser disclosure.
        </small>
    </div>
</div>